// Core
import React from 'react';

// Libraries
import { useTheme } from 'styled-components';

// Hooks
import { useBreakpoint } from '../../hooks/useBreakpoint';
import { useOverflowTooltip } from '../../hooks/useOverflowTooltip/useOverflowTooltip';

// Types
import { Theme } from '../../types/theme';

// Components
import { CheckboxIndeterminate, CheckboxLine } from '../../layout/icons';
import {
  Paragraph,
  ParagraphSize,
  ParagraphWeight,
} from '../../layout/elements/Paragraph';
import { Tooltip } from '../../layout/elements/Tooltip';

// Component
import {
  Container,
  Content,
  DescriptionContainer,
} from './EnableItem.style';
import { EnableItemProps, EnableItemStatus } from './EnableItem.types';

function EnableItem({
  className,
  description,
  enabled,
  status = EnableItemStatus.active,
  testId,
}: EnableItemProps): JSX.Element {
  // Dependencies
  const theme: Theme = useTheme();
  const { isXs } = useBreakpoint();

  const {
    containerRef,
    contentRef,
    isTooltipVisible,
  } = useOverflowTooltip({
    overflowCheckTriggers: description,
    widthOffset: 16,
  });

  return (
    <Container
      data-testid={testId}
      className={className}
      enabled={enabled}
      status={status}
    >
      {enabled ? <CheckboxLine /> : <CheckboxIndeterminate />}
      <Content ref={containerRef}>
        {isTooltipVisible ? (
          <Tooltip text={description}>
            <DescriptionContainer ref={contentRef}>
              <Paragraph
                color={theme.color.enableItem.textColor}
                size={
                  isXs
                    ? ParagraphSize.xs
                    : ParagraphSize.sm
                }
                weight={ParagraphWeight.medium}
                preventOverflow
              >
                {description}
              </Paragraph>
            </DescriptionContainer>
          </Tooltip>
        ) : (
          <DescriptionContainer ref={contentRef}>
            <Paragraph
              color={theme.color.enableItem.textColor}
              size={
                isXs
                  ? ParagraphSize.xs
                  : ParagraphSize.sm
              }
              weight={ParagraphWeight.medium}
              preventOverflow
            >
              {description}
            </Paragraph>
          </DescriptionContainer>
        )}
      </Content>
    </Container>
  );
}

export { EnableItem };
